<template>
    <Paper class="desc-module-root p-5">
        <div class="post-description">
            <div v-if="isLoading">
                <PresentationSkeleton />
            </div>
            <div v-else v-html="description" />
        </div>
    </Paper>
</template>

<script>
import PresentationSkeleton from '~/components/skeletons/PresentationSkeleton';

export default {
    name: 'DescriptionModule',
    components: { PresentationSkeleton },
    props: {
        data: Object,
        isLoading: Boolean,
    },
    computed: {
        description() {
            return this.data.description;
        },
    },
};
</script>

<style></style>
